import store from '@/store';
import api from '@/api/auth';

export default {
  logout() {
    return new Promise((resolve) => {
      api.logout().then(() => {
        store.commit('auth/setUser', null);
        resolve();
      });
    });
  },
  goToRouteAfterLogin(route) {
    store.commit('auth/setRouteAfterSuccessfulLogin', route);
  },
};
